"use client";
import React, { useEffect } from "react";
import { HeroParallax } from "@/components/ui/hero-parallax";
import Loader from "@/components/Loader";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { fetchProjects, fetchHeroSections } from "@/store/slices/landingSlice";

export function HeroParallaxDemo() {
    const dispatch = useAppDispatch();
    const { data: projects, loading } = useAppSelector((state) => state.landing.projects);
    const { data: heroSections } = useAppSelector((state) => state.landing.hero);
    const { mode } = useAppSelector((state) => state.theme);

    useEffect(() => {
        dispatch(fetchProjects({}));
        dispatch(fetchHeroSections());
    }, [dispatch]);

    // Convert projects to HeroParallax format
    const products = projects
        .filter(project => project.imageUrls && project.imageUrls.length > 0)
        .map((project, index) => ({
            id: project._id || project.id || `project-${index}`,
            title: project.title,
            link: project.liveUrl || "#",
            thumbnail: project.imageUrls?.[0] || project.images?.[0] || "",
        }));

    // Convert hero sections to slides format
    const slides = heroSections.map((section) => ({
        badge: section.badge,
        title: section.title,
        highlight: section.highlight,
        desc: section.subtitle,
        cta1: "Get Started",
        cta2: "View Portfolio",
    }));

    // if (loading) {
    //     return (
    //         <div className={`h-screen w-full flex items-center justify-center transition-colors duration-700 ${mode === "dark" ? "bg-[#0B0F19]" : "bg-slate-50"}`}>
    //             <Loader loading={loading} services={[]} mode={mode} />
    //         </div>
    //     );
    // }

    return (
        <HeroParallax
            products={products.length > 0 ? products : fallbackProducts}
            slides={slides.length > 0 ? slides : undefined}
        />
    );
}

// Fallback products if no projects are available
const fallbackProducts = [
    {
        id: "fallback-1",
        title: "Cal.com",
        link: "https://cal.com",
        thumbnail: "/hero/cal-com.webp",
    },
    {
        id: "fallback-2",
        title: "Dub.co",
        link: "https://dub.co",
        thumbnail: "/hero/dub-co.webp",
    },
    {
        id: "fallback-3",
        title: "Formbricks",
        link: "https://formbricks.com",
        thumbnail: "/hero/formbricks-com.webp",
    },
    {
        id: "fallback-4",
        title: "Novu",
        link: "https://novu.com",
        thumbnail: "/hero/novu-co.webp",
    },
    {
        id: "fallback-5",
        title: "OpenStatus",
        link: "https://openstatus.dev",
        thumbnail: "/hero/openstatus-dev.webp",
    },
    {
        id: "fallback-6",
        title: "Papermark",
        link: "https://papermark.io",
        thumbnail: "/hero/papermark-io.webp",
    },
    {
        id: "fallback-7",
        title: "Plane",
        link: "https://plane.so",
        thumbnail: "/hero/plane-so.webp",
    },
    {
        id: "fallback-8",
        title: "PocketBase",
        link: "https://pocketbase.io",
        thumbnail: "/hero/pocketbase-io.webp",
    },
    {
        id: "fallback-9",
        title: "Rally",
        link: "https://rally.com",
        thumbnail: "/hero/rally-com.webp",
    },
    {
        id: "fallback-10",
        title: "Resend",
        link: "https://resend.com",
        thumbnail: "/hero/resend-com.webp",
    },
    {
        id: "fallback-11",
        title: "Trigger.dev",
        link: "https://trigger.dev",
        thumbnail: "/hero/trigger-dev.webp",
    },
    {
        id: "fallback-12",
        title: "Typebot",
        link: "https://typebot.io",
        thumbnail: "/hero/typebot-io.webp",
    },
    {
        id: "fallback-13",
        title: "Algochurn",
        link: "https://algochurn.com",
        thumbnail: "/hero/imgi_8_algochurn.webp",
    },
];
